// components/ResourcesPage.jsx

import React from 'react';
import { Card, Typography, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  InfoCircleOutlined,
  BulbOutlined,
  FileTextOutlined,
  CompassOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

const ResourcesPage = () => {
  const navigate = useNavigate();

  const cardData = [
    {
      title: 'Information',
      icon: <InfoCircleOutlined style={{ fontSize: '64px', color: '#1890ff' }} />,
      description: 'Training guides, disability specific information, directory and SEND support information',
      route: '/resources/information',
      color: '#E6F7FF',
    },
    {
      title: 'Advice',
      icon: <BulbOutlined style={{ fontSize: '64px', color: '#faad14' }} />,
      description: 'Read our advice on managing SEND, supporting best practice, inclusion, neurodiversity and more',
      route: '/resources/advice',
      color: '#FFFBE6',
    },
    {
      title: 'Resources',
      icon: <FileTextOutlined style={{ fontSize: '64px', color: '#52c41a' }} />,
      description: 'Access how to guides, visual aids, tools and other practical resources and helpful guides',
      route: '/resources/resource',
      color: '#F6FFED',
    },
    {
      title: 'Guidance',
      icon: <CompassOutlined style={{ fontSize: '64px', color: '#eb2f96' }} />,
      description: 'Read the latest statutory SEND guidance and codes of practice',
      route: '/resources/guidance',
      color: '#FFF0F6',
    },
  ];

  const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Title level={2} style={{ textAlign: 'center', marginBottom: '40px' }}>
        Resources
      </Title>
      <Row gutter={[24, 24]}>
        {cardData.map((card) => (
          <Col xs={24} sm={12} md={12} lg={12} key={card.title}>
            <Card
              hoverable
              onClick={() => handleCardClick(card.route)}
              style={{
                borderRadius: '8px',
                backgroundColor: card.color,
                minHeight: '200px',
                height: 'auto',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Row
                align="middle"
                style={{ width: '100%' }}
                gutter={[0, 16]}
              >
                <Col xs={24} sm={6} style={{ textAlign: 'center' }}>
                  {card.icon}
                </Col>
                <Col xs={24} sm={18}>
                  <Title level={3} style={{ marginBottom: '8px' }}>{card.title}</Title>
                  <Text>{card.description}</Text>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ResourcesPage;
